import type { TNavbarDropdownElementColumn } from '@shared/dream-components';
import { NavbarMenuDropdownColumn as NavbarMenuDropdownColumnElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TNavbarDropdownElementColumn;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuDropdownColumn = ({ node, children, screen }: Props) => {
  return (
    <NavbarMenuDropdownColumnElement element={node} screen={screen}>
      {children}
    </NavbarMenuDropdownColumnElement>
  );
};

export default NavbarMenuDropdownColumn;
